'use client';

import { useSWRConfig } from 'swr';
import useSWRMutation from 'swr/mutation';

import { deleteUserStorageItems } from '@/api/userStorage';
import { adaptMutation } from '@/modules/common/helpers/swr';
import { userStorageKeys } from '../keys';

export const useDeleteUserStorageItems = () => {
  const { mutate } = useSWRConfig();

  return useSWRMutation(
    'deleteUserStorageItems',
    adaptMutation(deleteUserStorageItems),
    { onSuccess: () => mutate(userStorageKeys.all) }
  );
};
